// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QHyz","badges":"styles_badges__OvtRm"};